(function() {

  const init = () => {
    var elements = document.querySelectorAll('[data-module-slider]');

    if (!elements.length) {
      return;
    }

    elements.forEach(element => {
      var options = element.getAttribute('data-module-slider');
      options = JSON.parse(options || '{}');

      $(element).slick({
        arrows: options.arrows,
        dots: options.dots,
        fade: options.fade,
        autoplay: !!options.autoplay,
        autoplaySpeed: options.autoplay,
        slidesToShow: options.slidesToShow,
        slidesToScroll: options.slidesToScroll,
        infinite: options.infinite,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: options.mobileslidesToShow,
              slidesToScroll: options.mobileslidesToScroll,
              dots: options.mobileDots,
              arrows: options.mobileArrows
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: options.tabletslidesToShow,
              slidesToScroll: options.tabletslidesToScroll
            }
          }
        ]
      });
    });
  };

  return init();
})();
